import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ProductDevDocumentTableFilterSchema } from './-zod-schema';

// プロダクト詳細 > 開発ドキュメントタブ。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx 側で
// 遅延ロードして bundle 分割する（他のタブ・ページと同じ規約）。
export const Route = createFileRoute('/_stacktrace/products/$id/_layout/dev-documents/')({
  validateSearch: zodValidator(ProductDevDocumentTableFilterSchema)
});